export const getTimeStamp = (value: string) => {
  const timeStamp = new Date(value).getTime();
  return timeStamp;
};
